import {
  getSubVerticalPath,
  getVerticalPath,
  SubVertical,
  subVerticalConfig,
  Vertical,
  verticalConfig,
} from 'common/constants'
import { Breadcrumb } from 'common/types/entities/api/window'
import { getHomeUrl } from 'common/utils/url'

export const defaultBreadcrumbs = (vertical: Vertical, subVertical: SubVertical): Breadcrumb[] => {
  const breadcrumbs: Breadcrumb[] = []
  breadcrumbs.push({
    text: '네이버쇼핑',
    urlPc: getHomeUrl(true),
  })

  const currentSubVerticalConfig = subVerticalConfig[subVertical]
  if (verticalConfig[vertical].subVerticals.length === 1) {
    breadcrumbs.push({
      text: subVertical === SubVertical.FOREIGN ? currentSubVerticalConfig.fullName : currentSubVerticalConfig.name,
      urlPc: `${getSubVerticalPath(subVertical)}/home`,
    })
  } else {
    breadcrumbs.push({
      text: verticalConfig[vertical].name,
      urlPc: `${getVerticalPath(vertical)}/home`,
    })
    breadcrumbs.push({
      text: currentSubVerticalConfig.name,
      urlPc: `${getSubVerticalPath(subVertical)}/home`,
    })
  }

  return breadcrumbs
}
